/* Hyperush — scroll reveal. CSS does the animation; JS only adds the class.
   Fails open: anything not revealed within 2.5s is shown regardless. */
(function () {
  var FAILSAFE_MS = 2500;

  function showAll(els) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.hy-reveal:not(.is-in)'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showAll(els);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    els.forEach(function (el) { io.observe(el); });

    // Never leave content hidden if the observer never fires.
    window.setTimeout(function () { showAll(els); }, FAILSAFE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
